import { TableCell, withStyles, createStyles, Theme } from '@material-ui/core';

export const SHeadTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      fontWeight: 700,
    },
  })
)(TableCell);
